import ToggleCaption from '../shared/ToggleCaption';
import OtherClaps from '@/external/icons/OtherClaps';

type Props = { isLiked: boolean; total?: number; onClick: () => void };

const ToggleDesktop: FC<Props> = ({ isLiked, total, onClick }) => (
  <div className="inline-container">
    <div className="inline-container gap-1" id="clapp-toggle" onClick={onClick}>
      <span className="text-moon-10-caption font-medium uppercase text-trunks">
        <ToggleCaption total={total} />
      </span>
      <div className="pointer-events-none flex text-moon-24">
        <OtherClaps className={isLiked ? 'text-piccolo' : 'text-trunks'} />
      </div>
    </div>
  </div>
);

export default ToggleDesktop;
